import { render, staticRenderFns } from "./MotivoMovimientoForm.vue?vue&type=template&id=2f8c378a&"
import script from "./MotivoMovimientoForm.vue?vue&type=script&lang=js&"
export * from "./MotivoMovimientoForm.vue?vue&type=script&lang=js&"
import style0 from "./MotivoMovimientoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports